import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import ListFiles from "./List";
import Read from "./Read";
import NewEntry from "./New";

const Entries = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route path={`${match.url}/New`}>
        <NewEntry />
      </Route>
      <Route path={`${match.url}/List`}>
        <ListFiles />
      </Route>
      <Route path={`${match.url}/:id`}>
        <Read />
      </Route>
      <Route path={`${match.url}`}>
        <ListFiles />
      </Route>
    </Switch>
  );
};

export default Entries;
